import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

type RecordType = "application" | "screening" | "monitoring";

type LinkRecordProfileParams = {
  recordId: number;
  profileId: number;
  recordType: RecordType;
};

const getRecordUrl = (recordType: RecordType, recordId: number) => {
  if (recordType === "monitoring") {
    return `${env.verifyServiceUrl}individual/monitoring/${recordId}/`;
  }

  return `${env.verifyServiceUrl}individual/individual/${recordId}/`;
};

export const useLinkRecordProfile = () => {
  const { authHeader } = useAuth();

  return useMutation(
    ({ recordId, profileId, recordType }: LinkRecordProfileParams) =>
      axios.patch(
        getRecordUrl(recordType, recordId),
        { profile: profileId },
        {
          headers: {
            Authorization: authHeader,
          },
        },
      ),
  );
};
